// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__2UrLv","header":"MergedInvoice_header__1_gj-"};